import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { UieventhubService } from "@src/app/helpers/uieventhub/uieventhub.service";
import { Subscription, tap } from "rxjs";
import {
  trigger,
  state,
  style,
  animate,
  transition,
} from "@angular/animations";
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: "app-loader",
  templateUrl: "./loader.component.html",
  styleUrls: ["./loader.component.css"],
  animations: [
    trigger("inbgOutAnimation", [
      transition(":enter", [
        style({ opacity: 0 }),
        animate("0.2s ease-out", style({ opacity: 1 })),
      ]),
      transition(":leave", [
        style({ opacity: 1 }),
        animate("0.2s ease-in", style({ opacity: 0 })),
      ]),
    ]),
    trigger("taskdoneAnimation", []),
  ],
})
export class LoaderComponent implements OnInit {
  currentRoute: string = "";
  loaders: number = 0;
  sub: Subscription;
  constructor(private uieventhub: UieventhubService, private router: Router) {
    this.sub = this.uieventhub.loaders$.pipe(untilDestroyed(this)).subscribe(list => {
      //handle missed removes of loaders
      //on every new loader list, extend timeout to clear loaders after 30 secs

      setTimeout(() => {
        if (list.length > 0) {
          this.loaders = 0;
          this.uieventhub.clearLoaders();
          //console.log("loaders overwrite after 30 secs. Hangning loaders list:", list);
        }
      }, 10000);

      //console.log("loaders", list);

      if (list.length == 0) {
        // setTimeout(() => {
        this.loaders = 0;
        //}, 200);
      } else {

        this.loaders = list.length;
      }
      this.currentRoute = this.router.url.split("/")[1];
      if (this.router.url.split("/")[2] == "project") {
        this.currentRoute = this.currentRoute + "/" + this.router.url.split("/")[2];
      }
      //console.log("currentRoute", this.currentRoute);

    });
  }

  ngOnInit() {

  }
  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
